import { Icon } from '@manychat/icons'

export enum FlowChartTriggerIconType {
  ICON,
  EXTERNAL,
}

export interface FlowChartTriggerIcon {
  type: FlowChartTriggerIconType.ICON
  icon: Icon | null
}

export interface FlowChartTriggerIconExternal {
  type: FlowChartTriggerIconType.EXTERNAL
  icon: string | null
}

export interface FlowChartTrigger {
  id: string
  icon: FlowChartTriggerIcon | FlowChartTriggerIconExternal
  title: string
  subtitle: string[]
  subtitleIcon: Icon | null
  isActive: boolean
  isInteractive: boolean
}
